import { render } from "./OrderChitItem.vue?vue&type=template&id=6601803a&scoped=true"
import script from "./OrderChitItem.vue?vue&type=script&lang=js"
export * from "./OrderChitItem.vue?vue&type=script&lang=js"

import "./OrderChitItem.vue?vue&type=style&index=0&id=6601803a&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6601803a"]])

export default __exports__